import { render, staticRenderFns } from "./ModalCreatePack.vue?vue&type=template&id=969eb8da&scoped=true"
import script from "./ModalCreatePack.vue?vue&type=script&lang=js"
export * from "./ModalCreatePack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969eb8da",
  null
  
)

export default component.exports